import { useTranslate } from '../../hooks'
import { Button, Icon, Row, Typography } from '@repo/ui/components'
import { useIsDesktop } from '@repo/ui/hooks'

interface AdvancedTradeBoxBalanceDisplayProps {
  title: string
  max: number
  currencyLabel: string
  onMaxClick?: () => void
  color?: 'positive' | 'negative' | 'neutral'
}

export const AdvancedTradeBoxBalanceDisplay = (
  props: AdvancedTradeBoxBalanceDisplayProps,
) => {
  const { title, max, currencyLabel, onMaxClick, color = 'neutral' } = props
  const { t } = useTranslate()
  const isDesktop = useIsDesktop()

  const colorClasses = {
    positive: 'text-positive-main',
    negative: 'text-negative-main',
    neutral: 'text-neutral-main',
  }

  return (
    <Row className='justify-between items-center mb-xs'>
      <Typography
        size='sm'
        color='text-neutral-surface-80'
        className='whitespace-nowrap'
      >
        {t(title as keyof typeof t)}
      </Typography>

      <Row className='items-center gap-xs justify-end'>
        <Typography size='md' weight='bold' className={colorClasses[color]}>
          {max.toLocaleString()}
        </Typography>
        <Typography size='xs' color='text-neutral-surface-80'>
          {currencyLabel}
        </Typography>
        {onMaxClick && (
          <Button
            type='button'
            size='xs'
            variant={isDesktop ? 'ghost' : 'fill'}
            className='p-3xs rounded-xs scale-75'
            onClick={onMaxClick}
            aria-label='Max Balance'
            startIcon={
              <Icon name='PlusLine' size='xs' color='fill-base-main' />
            }
          />
        )}
      </Row>
    </Row>
  )
}
